export default __webpack_public_path__ + "static/media/colgante-estrella-de-david.0ede4a8b.png";